module.exports = __webpack_public_path__ + "static/media/Ashley A.272ab12b.png";